<template>
    <b-form-checkbox v-model="boolValue" switch />
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            boolValue: false
        };
    },

    watch: {
        value: {
            handler() {
                this.boolValue = this.value;
            },
            immediate: true
        },

        boolValue() {
            this.$emit('input', this.boolValue);
        }
    }
};
</script>
